import { pleaseConfirm } from "../utils/common";
var VARIANTS = {
  SEND_QUOTE: "that you have read and understood the Privacy Policy"
};
var validGDPRAgreement = function validGDPRAgreement(value) {
  var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "SEND_QUOTE";
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = pleaseConfirm(VARIANTS[form] || VARIANTS.SEND_QUOTE);
  }
  return error;
};
export default validGDPRAgreement;